import * as React from 'react'

import { Box, Card, Grid, Skeleton } from '@factorialco/deprecated-design-system'

export const SmartActionsSkeleton = () => {
  return (
    <>
      <Box gap="s8">
        <Skeleton height="s24" width="s140" />
        <Skeleton height="s24" width="full" />
        <Skeleton height="s24" width="s360" />
        <Skeleton height="s16" width="s96" />
      </Box>

      <Box paddingTop="s40" gap="s24">
        <Skeleton height="s16" width="s200" />
        <Grid variant="fixed">
          <SmartActionsCardSkeleton />
        </Grid>
      </Box>
      <Box paddingTop="s24" gap="s24">
        <Skeleton height="s16" width="s240" />
        <Grid variant="fixed">
          <SmartActionsCardSkeleton />
          <SmartActionsCardSkeleton />
        </Grid>
      </Box>
    </>
  )
}

const SmartActionsCardSkeleton = () => {
  return (
    <Box gridColSpan={{ xxs: 6 }}>
      <Card>
        <Card.Content>
          <Box justifyContent="spaceBetween" width="full" paddingBottom="s6">
            <Skeleton height="s32" width="s32" />
          </Box>
          <Box gap="s12" paddingTop="s12">
            <Skeleton height="s16" width="s200" />
            <Skeleton height="s12" width="s240" />
            <Skeleton height="s12" width="s140" />
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
